import { Fonts } from '@/constants/font';
import { Keys } from '@/constants/key';
import { Tr } from '@/i18n/i18n';
import CU from '@/utils/c-u';
import { StringUtils } from '@/utils/string-utils';
import BBCodeText from 'phaser3-rex-plugins/plugins/bbcodetext';
import { VerticalStandardPanel } from './vertical-standard-panel';
import SpriteUtils from '@/utils/sprite-utils';
import TextUtils from '@/utils/text-utils';

export class GiftNotificationPanel extends VerticalStandardPanel {

    constructor(scene: Phaser.Scene, canvas: HTMLCanvasElement, senderNames: string[], showPurchasePanelCallback: CallableFunction) {
        super(scene, canvas, Tr('gft'));
        this.xButton.setVisible(false);

        const somethingSpecialText  = TextUtils.addTextByFamily(scene, Tr('something.special'),
            0, this.getXButtonY() * CU.S + 120 * CU.S, '#71ff66', 21, 'normal', this.getContentWidth(), Fonts.MYRIADPRO_REGULAR);

        const uniqueSenderNames = [...new Set(senderNames)];
        const notification = StringUtils.formatString(Tr('special.gift'), uniqueSenderNames.join(', '));
        const specialGiftText = TextUtils.addTextByFamily(scene, notification,
            0, this.getXButtonY() * CU.S + 200 * CU.S, '#ffcc00', 21, 'normal', this.getContentWidth(), Fonts.MYRIADPRO_REGULAR);

        const image = SpriteUtils.addImage(this.scene, 0, this.getXButtonY() * CU.S + 300 * CU.S, Keys.ATLAS_PROFILE, Keys.NEW_GIFT).setScale(CU.S, CU.S);

        this.add([somethingSpecialText, specialGiftText, image]);
        this.addButton(Tr('wtch').toUpperCase(), Keys.UI_ART_GREEN_BUTTON, Keys.ATLAS_PROFILE, Keys.UI_GOLDEN_CHECK, () => showPurchasePanelCallback());
    }

    private getContentWidth(): number {
        return 300;
    }

}